/**
 * JSON based feature flags.
 *
 * Insert new flags alphabetically inside the keep-sorted block, with a date and a description.
 *
 * https://docs.launchdarkly.com/home/getting-started/feature-flags
 */

export const JSON_FEATURE_FLAGS = [
  // keep-sorted:begin
  // 2026-08-16 (ctriolo) - AI assistant message buffer and Streamdown animation timing.
  // Example: { "bufferMs": 1000, "streamdownStaggerMs": 40 }. A smaller stagger is faster.
  'ai-assistant-streaming',

  // Enables and supplies the text for an in app banner
  'in-app-banner',

  // 2026-01-29 (ctriolo) - Array of enabled language codes for the language selector
  // Example: ["en", "fr", "es", "ko", "zh-TW", "zh-CN"]
  // If null, undefined, empty, or only contains "en", the selector is hidden
  'languages',

  // Optional Statuspage component IDs for LD-targeted status banner filtering
  'status-page-banner',

  // JSON mapping of which features are in beta. Keys match flags in FeatureFlagBool.ts
  'user_beta_feature_tags',
  // keep-sorted:end
] as const;

export type FeatureFlagJson = (typeof JSON_FEATURE_FLAGS)[number];
